import { destroy, get, uploadMutipleFile } from "../apis/httpClient";

export const pagingMedia = (params)=>get('/api/v1/media/paging',params)
export const createMedia = async (formData) => await uploadMutipleFile('/api/v1/media/create', formData);
export const deleteMedia = (body) => destroy('/api/v1/media/delete',body)